<template>
  <div class="pdf-wrap" :class="{ 'pdf-wrap--loading': loading }">
    <div class="pdf-container" v-infinite-scroll="getMorePage" infinite-scroll-immediate="false">
      <Pdf v-for="i in curShowPages" :key="i" :src="src" :page="i"></Pdf>
    </div>
  </div>
</template>

<script>
import Pdf from 'vue-pdf'
import infiniteScroll from 'vue-infinite-scroll'
const PAGE_SIZE = 5
export default {
  components: { Pdf },
  directives: { infiniteScroll },
  data() {
    return {
      curShowPages: PAGE_SIZE,
      loading: false,
      src: undefined,
      numPages: undefined
    }
  },
  mounted() {
    const { title, url } = this.$route.query
    document.title = title
    this.getPdfFile(url)
  },
  methods: {
    getPdfFile(url) {
      if (url) {
        this.loading = true
        const loadingTask = Pdf.createLoadingTask({
          url,
          cMapUrl: process.env.BASE_URL + 'cmaps/',
          cMapPacked: true
        })
        loadingTask.promise.then((pdf) => {
          this.src = loadingTask
          this.numPages = pdf.numPages
          this.loading = false
        })
      }
    },
    getMorePage() {
      let curShowPages = this.curShowPages + PAGE_SIZE
      if (curShowPages >= this.numPages) {
        curShowPages = this.numPages
      }
      this.curShowPages = curShowPages
    }
  }
}
</script>

<style lang="scss">
.pdf-wrap {
  .pdf-container {
    height: 100vh;
    overflow-y: auto;
  }
}
.pdf-wrap--loading {
  position: relative;
  &::after {
    content: '正在加载...';
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    line-height: 100vh;
    text-align: center;
    background: rgba(var(--font-color-2-rgb), 0.3);
    color: var(--main-color-1);
  }
}
</style>
